module.exports = __webpack_public_path__ + "img/banner_detail_1.aa3ba6f8.png";